var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.668H7.5V9.16797H6V8.16797H7.5V6.66797H8.5V8.16797H10V9.16797H8.5V10.668Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1044 2H4.42391C3.82142 2 3.33301 2.48841 3.33301 3.09091V12.9091C3.33301 13.5116 3.82142 14 4.42391 14H12.0603C12.6627 14 13.1512 13.5116 13.1512 12.9091V5.04679L10.1044 2ZM4.42391 3.09091H8.78754V5.27273C8.78754 5.87522 9.27594 6.36363 9.87847 6.36363H12.0603V12.9091H4.42391V3.09091ZM9.87847 5.27273V3.31685L11.8343 5.27273H9.87847Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.190d68f757f9359d948abbf3ef3614ba.svg";
export { ForwardRef as ReactComponent };